<template>
  <target-data
    v-if="currentShapeTarget"
    ref="target"
    :key="currentShapeTarget.id"
    :session-program="sessionProgram"
    :target="currentShapeTarget"
    :data="data"
    :active-prompt-levels="activePromptLevels"
    :dense="dense"
    :tiny="tiny"
    :focused="focused"
    :disable="isDisabled"
    :workflow-statuses="workflowStatuses"
    :prevent-duplicates-on-trial="preventDuplicatesOnTrial"
    @record-program-data="onRecordProgramData"
    @record="onRecordData"
  />
  <q-badge
    v-else
    color="warning"
    :label="$t('run.collectData.warningTargetHasNoSubtargets', { targetLabel })"
    multi-line
    class="no-target-badge"
  />
</template>
<script>
import { chain } from 'lodash';
import DataCollection from 'src/mixins/DataCollection';
import { defineAsyncComponent } from 'vue';

export default {

  name: 'ShapingTarget',

  components: { TargetData: defineAsyncComponent(() => import('components/Programs/DataCollection/TargetData')) },

  mixins: [DataCollection],

  // Even though this function doesn't emit 'record' it is required to be here
  // to make sure we break the emit-chain and don't emit 'record' from the
  // TargetData component.
  emits: ['record-program-data', 'record-target', 'record'],

  computed: {

    currentShapeTarget() {
      return chain(this.target).get('subTargets', []).last().value();
    }, // currentShapeTarget()

    targetLabel() {
      return this.target?.label || '';
    }, // targetName()

  },

  methods: {

    finishSession() {
      if (chain(this.$refs).get(['target', 'finishSession']).isFunction().value()) {
        return this.$refs.target.finishSession();
      }
    },

    onRecordProgramData(sessionProgram, dataObj) {
      this.$emit('record-program-data', sessionProgram, dataObj);
    }, // onRecordProgramData()

    onRecordData(sessionProgram, target, data) {
      this.$emit('record-target', target, data);
    }, // onRecordData()

  },
};
</script>

<style lang="scss" scoped>
.no-target-badge {
  max-width: 200px;
  word-break: keep-all;
  font-size: 12px;
}
</style>
